<template>
    <span class="lg:inline-block" style="margin-top: 0.4rem; margin-right: 0.5rem">
    <!--
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="28" height="28" fill="#718096">
            <path d="M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16z"/>
        </svg>
        -->
        <Icon name="folder" type="outline" />
    </span>
    <span class="text-gray-600 font-bold">
    </span>
    <Dropdown>
        <Button class="block shrink-0" variant="ghost" padding="tight" :trailing-icon="contracts.length > 1 ? 'chevron-down' : ''" style="margin-left: 0.2rem;">
            <span class="inline-flex items-center shrink-0 gap-2">
                <span class="whitespace-nowrap">
                    {{ contract.nombre || 'No hay contracto selecccionado' }}
                </span>
            </span>
        </Button>

        <template #menu style="margin-top: 15px !important;" v-if="contracts.length > 1">
            <DropdownMenu width="auto" class="px-1">
                <div v-for="contra in contracts" :key="contra.id">
                    <nav class="py-1" v-if="contra.id != contract.id">
                    <DropdownMenuItem as="button" @click="attemptSend(contra.id)">
                        {{ contra.name.toUpperCase() }}
                    </DropdownMenuItem>
                    </nav>
                </div>
            </DropdownMenu>
        </template>
    </Dropdown>
</template>

<script setup>
    import { defineProps, defineEmits } from 'vue';
    import { Button, Icon } from 'laravel-nova-ui';

    const emit = defineEmits(['attempt']);
    const props = defineProps({
        contract: Object,
        contracts: Array,
    });

    const attemptSend = (id) => {
        emit('attempt', {id});
    };
</script>
